import { ApplicationTypes, OvalCylinderHole, attachComponent, featureLabels } from 'metalworks-domain'

import {
  ArrowHeadType,
  detailComponent,
  dimensionIndicatorComponent,
  entityHeaderComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { GenericDistancePropertyPage } from '../ui/property-pages/GenericDistancePropertyPage'
import { bendHoleDimensionIndicatorCoordinates, scaleIndicator } from './common'

export const ovalCylinderHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('OvalCylinderHole')
    .attach(() => {
      return {
        title: featureLabels[OvalCylinderHole.type],
        subtitle: '',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/oval-cylinder-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('OvalCylinderHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <GenericDistancePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('OvalCylinderHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),

  attachComponent
    .withEntity('OvalCylinderHole')
    .withComponent(dimensionIndicatorComponent, 'radius')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Finalization],
    })
    // TODO: memoEval
    .attach(s => {
      return {
        ...bendHoleDimensionIndicatorCoordinates(s, {
          startY: -s.height / 4,
          endY: -s.height / 4,
          startX: -s.width / 2,
          endX: s.width / 2,
          startZ: s.$plate.thickness + 0.1,
          endZ: s.$plate.thickness + 0.1,
        }),
        arrowHeadType: ArrowHeadType.CONE,
        arrowHeadSize: 4,
        labelFontSize: scaleIndicator(4, 64, Math.max(s.$plate.$sizeX, s.$plate.$sizeY)),
        label: `R=${s.width / 2}`,
      }
    }),
]
